import '../css/Contact.css'
import { Link } from 'react-router-dom'

// should contain: email, phone #, local profile, imdb.

export default function Contact() {
    return (
      <div className='contact-view-box'>
        <div className='actual-contact-info'>
            <span className='email'>lizalicejohn@gmail.com</span>
            <span className='phone'>914.960.4939</span>
            <span className='insta'><Link to={{ pathname: "https://www.instagram.com/lizdrawsmonsters"}}>instagram</Link></span>
        </div>
      </div>
    )
}